import firebase from "firebase/app";
import "firebase/messaging";
import cookie from "react-cookies";

var firebaseConfig = {
  apiKey: "AIzaSyBUXdz-wBoMhrp26vls36OmCgQDUPNaQwk",
  authDomain: "cardoc-39be8.firebaseapp.com",
  projectId: "cardoc-39be8",
  storageBucket: "cardoc-39be8.appspot.com",
  messagingSenderId: "976101817160",
  appId: "1:976101817160:web:b5fb4e4d64dc2ebe24117d",
  measurementId: "G-EVL6GQ7QQB",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Firebase Messaging exige un contexte securise (HTTPS ou localhost).
// En HTTP simple, firebase.messaging() leve une exception : sans ce
// garde-fou, tout le bundle plante et la page reste blanche.
// On installe alors un objet inerte pour que les appels restent sans effet.
let messaging;
try {
  messaging = firebase.messaging();
} catch (err) {
  console.warn(
    "Firebase Messaging indisponible (contexte non securise).",
    err && err.message
  );
  messaging = {
    getToken: () => Promise.resolve(null),
    deleteToken: () => Promise.resolve(),
    onMessage: () => () => {},
    onBackgroundMessage: () => () => {},
    requestPermission: () => Promise.resolve("denied"),
    usePublicVapidKey: () => {},
    useServiceWorker: () => {},
  };
}

export const getToken = (setTokenFound) => {
  return messaging
    .getToken({
      vapidKey:
        "BIF1-LE5ooprIDC9D8N7ITFD5bWquRWGGkv_I3WSlpX8LHUqy-rvrcECoquIbAvmYo1fglNUT9QYmLE-DrVAZV4",
    })
    .then((currentToken) => {
      if (currentToken) {
        cookie.save("fcmtoken", currentToken, { path: "/" });
        setTokenFound(true);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        setTokenFound(false);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      // catch error while creating client token
    });
};

// Souscrit un handler aux messages foreground (à appeler dans un useEffect).
// Retourne une fonction de désabonnement. Chaque message déclenche le handler,
// pas seulement le premier (l'ancienne promesse ne se résolvait qu'une fois).
export const onMessageListener = (callback) => {
  const unsubscribe = messaging.onMessage((payload) => callback(payload));
  return typeof unsubscribe === "function" ? unsubscribe : () => {};
};
